export class StructureAddressDto {
  public id: number;
  public name: string;
  public address: string;
  public postalCode: string;
  public city: string;
  public main: boolean = false;
  public active: boolean = true;
  public publicReception: boolean = true;
  public phone?: string;
  public additionalAddress?: string;
  public geoJSON?: {
    geometry: { coordinates: { lon: number; lat: number } };
    properties: { label: string; housenumber: string; name: string; postcode: string; citycode: string; city: string; street: string };
  };
}
